import React from "react";

import OTPForm from "@components/OTPForm";

import { OTP_SCOPES } from "@utils/enum";

import { useLoginSharedData, useLoginSteps } from "../../hooks";

const LoginOTPStep = () => {
  const { sharedData } = useLoginSharedData();
  const { onPrevStep } = useLoginSteps();

  return (
    <OTPForm
      id={sharedData?.userDetails?.userId}
      email={sharedData?.userDetails?.userEmail}
      scope={OTP_SCOPES.LOGIN_USER}
      onSubmit={sharedData?.successCallback}
      onCancel={onPrevStep}
      onError={sharedData?.errorCallback}
    />
  );
};

export default LoginOTPStep;
